import { createAction } from 'redux-actions';

const SET_CONTACT_MESSAGES_DIRTY = 'SET_CONTACT_MESSAGES_DIRTY';

const action = createAction(SET_CONTACT_MESSAGES_DIRTY);
export const setContactMessagesDirty = (contactId: number) => action({ contactId });
